import * as React from 'react';
import * as Features from '../../../shared/Features';
import { IStylingUser } from '../Entities';
import StylingUserListRow from './StylingUserListRow';
import { Translate } from '../../../shared/LanguageService';

interface IStylingUsersListProps {
    stylingUsers: IStylingUser[];
    editStylingUser: (id: number) => void;
    viewlogs: (id: number) => void;
    deleteStylingUser: (id: number) => void;
    user: any;
    showRemoved: boolean;
}

const StylingUsersList = (props: IStylingUsersListProps) => {
    const showLogs = Features.hasFeature(Features.ViewLogs, props.user);
    const showStylingFirm = !(props.user.details.role === 'role/styling-admin');

    function filterRemoved(stylingUser) {
        if (props.showRemoved) {
            return true;
        }

        return !stylingUser.isRemoved;
    }

    return (
        <table className="table table-hover table-responsive">
            <thead>
                <tr>
                    <th>{Translate('styling-user/list/header/name')}</th>
                    <th>{Translate('styling-user/list/header/role')}</th>
                    <th>{Translate('styling-user/list/header/email')}</th>
                    <th>{Translate('styling-user/list/header/phone')}</th>
                    {showStylingFirm && <th>{Translate('styling-user/list/header/firm')}</th>}
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.stylingUsers &&
                    props.stylingUsers
                        .sort((a: IStylingUser, b: IStylingUser) => {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }

                            return 0;
                        })
                        .filter(filterRemoved)
                        .map((stylingUser: IStylingUser, index: number) => {
                            return (
                                stylingUser && (
                                    <StylingUserListRow
                                        key={index}
                                        stylingUser={stylingUser}
                                        editStylingUser={props.editStylingUser}
                                        viewlogs={props.viewlogs}
                                        deleteStylingUser={props.deleteStylingUser}
                                        user={props.user}
                                        showLogs={showLogs}
                                        showStylingFirm={showStylingFirm}
                                    />
                                )
                            );
                        })}
            </tbody>
        </table>
    );
};

export default StylingUsersList;
